export enum InviteToAccountErrorType {
  SameUserEmail = "same_user_email",
  InvalidEmail = "invalid_email",
}
